import React from "react";
import { ArrowRight, Building2, Hospital } from "lucide-react";
import Reveal from "./Reveal";
import { useLanguage } from "../i18n/LanguageContext";

const ICONS = [Hospital, Building2];

export default function ForClinics() {
  const { t } = useLanguage();
  const c = t.customers;

  return (
    <section id="clinics" data-testid="clinics-section" className="py-24 sm:py-32 border-t border-line">
      <div className="shell">
        <div className="max-w-[720px]">
          <Reveal className="kicker text-textsoft">{c.kicker}</Reveal>
          <Reveal as="h2" delay={1} className="mt-5 font-display text-[32px] sm:text-[42px] lg:text-[48px] font-semibold text-ink tracking-tight leading-[1.08]">
            {c.h2}
          </Reveal>
          <Reveal as="p" delay={2} className="mt-5 text-[17px] text-textsoft leading-[1.6]">{c.sub}</Reveal>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5">
          {c.cards.map((card, i) => {
            const Icon = ICONS[i] || Building2;
            const isHospital = i === 0;
            const accentBg = isHospital ? "bg-green-soft text-green-dark" : "bg-blue-soft text-blue-dark";
            const btnClass = isHospital ? "btn-green" : "btn-primary";
            return (
              <Reveal
                delay={i + 1}
                key={card.eyebrow}
                className={`glow flex flex-col rounded-2xl bg-white border p-8 sm:p-9 ${isHospital ? "grad-border relative border-transparent" : "border-line"}`}
              >
                <span className={`inline-flex w-11 h-11 items-center justify-center rounded-xl ${accentBg}`}>
                  <Icon size={20} strokeWidth={1.7} />
                </span>
                <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.18em] text-textsoft">{card.eyebrow}</div>
                <h3 className="mt-2 font-display text-[22px] font-semibold text-ink tracking-tight leading-snug">{card.h}</h3>
                <p className="mt-3 text-[15px] text-textsoft leading-[1.65] flex-1">{card.b}</p>
                <a href="#demo" className={`btn ${btnClass} mt-7 self-start group`}>
                  {card.cta}
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-white/20 group-hover:translate-x-0.5 transition-transform">
                    <ArrowRight size={13} strokeWidth={2.4} />
                  </span>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
